import {buildOptions} from './utils';

const TIME_OPTIONS = buildOptions({
  interval_unit: 'M',
  interval: 30,
  min_time: '00:00',
  max_time: '23:30',
});

const TIME_WITHOUT_MINUTES_OPTIONS = buildOptions();

const HOURS_OPTIONS = buildOptions({
  interval_unit: 'H',
  interval: 1,
  min_time: '00:00',
  max_time: '23:00',
});

export {TIME_OPTIONS, TIME_WITHOUT_MINUTES_OPTIONS, HOURS_OPTIONS};
